import { resolveSigningMessage, SignType } from '@mogul/shared';
import { signMessage } from '@wagmi/core';
import type { PropsWithChildren } from 'react';
import React, { useEffect } from 'react';

import { walletApi } from '../../../api';
import { linkWalletToUser } from '../../../api-helpers/user-wallets';
import { useAuth } from '../../../auth';
import { useWeb3State } from '../../../hooks/use-web3-state';

const linkWallet = async (address: string) => {
  try {
    await walletApi.checkIfLinked({ address });
  } catch (e) {
    const signed = await signMessage({
      message: resolveSigningMessage(SignType.link),
    });

    return linkWalletToUser(address, signed);
  }
};

export const Web3AuthProvider = ({ children }: PropsWithChildren<{}>) => {
  const { authenticated } = useAuth();
  const { walletDetails, isInitialized } = useWeb3State();

  useEffect(() => {
    if (!authenticated || !isInitialized || !walletDetails.address) {
      return;
    }

    void linkWallet(walletDetails.address);
  }, [authenticated, walletDetails.address, isInitialized]);

  return <>{children}</>;
};
